import { useMutation } from '@tanstack/react-query';
import useAxios from '../../../../../app/hooks/useAxios';

const useAuthOktaUserActivationSend = () => {
	const { post } = useAxios();

	const userActivateSend = (data: { login: string; locale: string }) => {
		return post(`/users/activate/login`, { login: data.login, language: data.locale });
	};

	return useMutation(userActivateSend);
};

export default useAuthOktaUserActivationSend;
